import {
  createSettingsParams,
  SettingsParamType,
} from '@wix/yoshi-flow-editor/tpa-settings';
import calendarSettingsParams, {
  ISettingsParams,
} from '../BookingCalendar/settingsParams';
import { AlignmentOptions, LayoutOptions } from '../../types/types';
import { AccessibilityHtmlTags } from '../../utils/accessibility/constants';

type WeeklyTimetableSettingsOverride = Pick<
  ISettingsParams,
  | 'textAlignment'
  | 'calendarLayout'
  | 'headerTitleHtmlTag'
  | 'headerServiceFilterVisibility'
  | 'headerStaffFilterVisibility'
  | 'headerLocationFilterVisibility'
  | 'headerTimezoneSelectionVisibility'
>;

const weeklyTimetableSettingsParams =
  createSettingsParams<WeeklyTimetableSettingsOverride>({
    calendarLayout: {
      getDefaultValue: ({ isMobile }) =>
        isMobile
          ? LayoutOptions.DAILY_AGENDA_WEEKLY_PICKER
          : LayoutOptions.WEEKLY_TIMETABLE,
    },
    textAlignment: {
      getDefaultValue: () => AlignmentOptions.CENTER,
    },
    headerTitleHtmlTag: {
      getDefaultValue: () => AccessibilityHtmlTags.SecondaryHeading,
    },
    headerServiceFilterVisibility: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    headerStaffFilterVisibility: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    headerLocationFilterVisibility: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => false,
    },
    headerTimezoneSelectionVisibility: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => false,
    },
  });

export default {
  ...calendarSettingsParams,
  ...weeklyTimetableSettingsParams,
};
